import { HttpClient } from "@angular/common/http";
import { inject, isDevMode } from "@angular/core";
import { TranslocoLoader, TranslocoMissingHandler } from "@jsverse/transloco";
import { Observable } from "rxjs";

export class TranslateJsonLoder implements TranslocoLoader {
  http = inject(HttpClient);

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`./assets/i18n/${lang}.json`);
  }
}

export const translateConfig = {
    availableLangs: ['en', 'es'],
    defaultLang: 'en',
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    fallbackLang: 'en',
    missingHandler: {
      useFallbackTranslation: false
    }
}

export class MissingTranslationHandler implements TranslocoMissingHandler {
    handle(key: string, config: any) {
        return (`[Verbiage Missing: ${key}]`);
    }
    
}
